import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Grid from '@mui/material/Grid'
import React, { ReactElement, ReactNode, useContext, useRef } from 'react'
import SettingContext from '../../services/context/setting-contentxt/setting-context';

interface iProps {headers:string[]|ReactNode []
  ,body:()=>ReactElement,onKeyUp?:(e:React.KeyboardEvent)=>void
  ,spans?:{[key:string]:number}
  ,units?:{[key:string]:string}
}
export default function InputTable({headers,body,onKeyUp,spans,units}:iProps) {
    const tabel = useRef(null);
    const {isPc}=useContext(SettingContext)



  return (
    
    <Grid  container size={12}>
          <Grid  container size={12}>
            <TableContainer
              component={Paper}
              className="editbleTable"
              ref={tabel as any}
              style={{ paddingTop: '0' }}
              onKeyUp={onKeyUp}
              >
              <Table sx={{ minWidth: 650 }} stickyHeader={true}
              
             >
              <TableHead>
                  <TableRow style={{width:'100%'}}
                 
                  >
                   {isPc && <TableCell></TableCell>}
                    {headers.map((ele: string | ReactNode, index: number) => (
                      <TableCell align="right" key={`${typeof(ele)==="string"?ele:'ele'}${index}`}
                      // colSpan={spans && typeof(ele)==='string' && spans[ele] ?spans[ele]: 1}
                    
                    
                      >
                        {typeof(ele)==="string"?
                        ele + `${units&& units[ele]? ` ${units[ele]} ` : ''}`
                        : ele
                      }
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody style={{ position: 'relative' }}
                 
                >
                  
                       {body()}
                    
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid
            container
            
            size={12}
            style={{ position: 'relative' }}
            className="tableAction">
            
          </Grid>
 </Grid>
  )
}
